import { render } from "./TopCasts.vue?vue&type=template&id=1dc23aea"
import script from "./TopCasts.vue?vue&type=script&lang=js"
export * from "./TopCasts.vue?vue&type=script&lang=js"

import "./TopCasts.vue?vue&type=style&index=0&id=1dc23aea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__